import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgxScrollTopModule} from 'ngx-scrolltop';
import {CarouselModule} from 'ngx-owl-carousel-o';
import {FormsModule} from '@angular/forms';
import {CountUpModule} from 'ngx-countup';
import {NgxTypedJsModule} from 'ngx-typed-js';
import {TooltipModule} from 'ng2-tooltip-directive';
import {RoutesModule} from './route/routes.module';
import {AppComponent} from './app.component';
import {PreloaderComponent} from './components/common/preloader/preloader.component';
import {NavbarComponent} from './components/common/navbar/navbar.component';
import {HowWeWorkComponent} from './components/common/how-we-work/how-we-work.component';
import {FooterComponent} from './components/common/footer/footer.component';
import {ContactComponent} from './components/common/contact/contact.component';
import {ChartsServicesComponent} from './components/common/charts/charts-service.component';
import {HomeComponent} from './components/home/home.component';
import {HomeChartComponent} from './components/common/home-chart/home-chart.component';
import {ChartsComponent} from './components/charts/charts.component';
import {ServicesModule} from './services/services.module';
import {AppHttpInterceptor} from './lib/rest-service/http-interceptor';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {createTranslateLoader} from './lib/core/translator/translator.service';
import {CoreModule} from './core/core.module';
import {NgOptimizedImage} from '@angular/common';
import {InfiniteScrollDirective} from 'ngx-infinite-scroll';
import {LoginComponent} from "./login/login.component";

@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    NavbarComponent,
    HomeChartComponent,
    HowWeWorkComponent,
    FooterComponent,
    ContactComponent,
    LoginComponent,
    ChartsServicesComponent,
    HomeComponent,
    ChartsComponent
  ],
  imports: [
    BrowserAnimationsModule,
    RoutesModule,
    HttpClientModule,
    CoreModule,
    NgxScrollTopModule,
    CarouselModule,
    FormsModule,
    CountUpModule,
    TooltipModule,
    ServicesModule,
    NgxTypedJsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    NgOptimizedImage,
    InfiniteScrollDirective
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
